<template>
  <transition name="van-fade">
      <div v-show="!beginPlay">
        <template v-if="!showHistoryDemand">
          <hr class="m-t-10 m-b-5"/>
          <van-row class="p-b-5">
              <van-col span="11">线路总长度：{{currentChooseLine.length}} KM</van-col>
              <van-col span="13">运行时间：{{currentChooseLine.runTime}}</van-col>
          </van-row>
          <van-row class="p-b-5">
              <van-col span="11">列车车型：{{currentChooseLine.group}}</van-col>
              <van-col span="13">车站数量：{{currentChooseLine.stationNumber}}站</van-col>
          </van-row>
          <p class="p-b-5">运营机构：{{currentChooseLine.operator}}</p>
          <p class="p-b-5">日客运量：{{currentChooseLine.remark}}</p>

          <p class="p-b-5" v-if="currentChooseLine.introduce">特色商圈：
            <span>{{currentChooseLine.introduce===''?'-':currentChooseLine.introduce.substr(0,80)}}</span>
            <span v-if="showMoreIntroduce">{{currentChooseLine.introduce.substr(80)}}</span>

            <a v-if="currentChooseLine.introduce.length>100" class="m-l-5" @click="showMoreIntroduce=!showMoreIntroduce">
              <span v-if="showMoreIntroduce">收起</span>
              <span v-else>查看更多...</span>
            </a>
          </p>

          <!-- 仅允许平台内的运营城市可见 -->
          <template v-if="isRuningCity" >
            <h3 v-show="materialImgs.length>0" class="text-center p-b-10">品牌投放</h3>

            <van-swipe v-show="materialImgs.length>0" ref="swipeImgs" lazy-render height="230" @change="swipChange" :initial-swipe="currentSwipePage">
              <!-- 6组图片轮播 -->
              <van-swipe-item v-for="page in totalPage" :key="page">
                <ImgsView :pageNumber="page" :query="materialQuery" :imgs="materialImgs" @on-demand-stations="handleShowDemandStations"/>
              </van-swipe-item>
            </van-swipe>

            <p v-if="isMiniProgram" class="p-t-20">
              <van-button type="warning"  size="large" @click="handleGoWechat">采购广告资源</van-button>
            </p>
          </template>
        </template>
        <template v-else>
          <van-row class="p-b-5">
              <van-col span="6">品牌：</van-col>
              <van-col span="14">{{historyDemandBrand}}</van-col>
          </van-row>
          <van-row class="p-b-5">
              <van-col span="6">覆盖人流：</van-col>
              <van-col span="18">{{brandDemandEntity.flow}} 人次</van-col>
          </van-row>
          <van-row class="p-b-5" v-show="showMoreStationName">
              <van-col span="6">投放站点：</van-col>
              <van-col span="18">
                <template v-for="(item,i) in brandDemandEntity.stations">
                  <span :key="'s'+i">
                    {{item}}<span v-if="i+1<brandDemandEntity.stations.length">，</span>
                  </span>
                </template>
              </van-col>
          </van-row>
          <van-row class="p-b-5" v-show="showMoreStationName">
              <van-col span="6">历史档期：</van-col>
              <van-col span="18">
                <p v-for="(item,i) in brandDemandEntity.schedules" :key="'h'+i">{{item}}</p>
              </van-col>
          </van-row>
          <p class="text-center">
            <a @click="showMoreStationName=!showMoreStationName">
              <span v-if="showMoreStationName">收起</span>
              <span v-else>查看更多...</span>
            </a>
          </p>
        </template>
      </div>
  </transition>
</template>

<script>
import { Col, Row, Image as VanImage, Button, Swipe, SwipeItem } from 'vant'
import ImgsView from './ImgsView'

import { getMaterialBasicInfoPage, getBrandMspInfo } from '@/api/msp'
import { toNumber } from '@/utils/wnumb_own'
const wx = require('weixin-js-sdk')

export default {
  props: {
    beginPlay: {
      type: Boolean,
      required: true
    },
    cityCode: {
      type: String,
      required: true
    },
    allLines: {
      type: Array,
      required: true
    }
  },
  components: {
    ImgsView,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem

  },
  data () {
    return ({
      currentChooseLine: {},
      materialImgs: [],
      materialQuery: {
        assetId: 0,
        pageSize: 6,
        pageNumber: 1,
        orderType: 1,
        produceType: 1,
        startDateStr: '2020-01-01',
        endDatStr: '2020-10-01'
      },
      totalPage: 0,
      currentImgPage: 0,
      isMiniProgram: false,
      showHistoryDemand: false,
      historyDemandBrand: '',
      currentSwipePage: 0,

      brandDemandEntity: {},
      showMoreStationName: false,
      showMoreIntroduce: false
    })
  },
  methods: {
    initPageData (assetId) {
      this.currentChooseLine = this.allLines.find(x => x.id === assetId)
      // 获取线路历史投放品牌
      if (this.isRuningCity) {
        this.materialQuery.assetId = assetId
        this.materialQuery.pageNumber = 1
        this.checkMiniProgram()
        this.loadLineMspImage()
        this.showHistoryDemand = false
      }
    },
    loadLineMspImage () {
      getMaterialBasicInfoPage(this.materialQuery).then(res => {
        this.materialImgs = res.list
        this.totalPage = res.totalPage
        this.$refs.swipeImgs.resize()
      })
    },
    handleGoWechat () { // 跳转至微信小程序
      wx.miniProgram.reLaunch({
        url: '/pages/home/index'
      })
    },
    checkMiniProgram () {
      var ua = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
      var envType = '#'

      if (ua !== null && ua.indexOf('micromessenger') > -1) { // 微信环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) { // 小程序环境下逻辑
            envType = true
          } else { // 非小程序环境下逻辑
            envType = false
          }
        })
      } else { // 非微信环境逻辑
        envType = false
      }

      this.isMiniProgram = envType
    },
    handleShowDemandStations (param) {
      this.showHistoryDemand = true
      this.historyDemandBrand = param.brandName

      let stationIds = []

      getBrandMspInfo({ brandId: param.brandId }).then(res => {
        this.brandDemandEntity = {
          stations: [],
          schedules: [],
          flow: 0
        }
        this.showMoreStationName = false
        this.showMoreIntroduce = false

        res.forEach(element => {
          element.domainList.forEach(stations => {
            if (!this.brandDemandEntity.stations.includes(stations.domainName)) {
              this.brandDemandEntity.stations.push(stations.domainName)
            }

            stationIds.push(stations.domainId)
          })

          this.brandDemandEntity.schedules.push(element.startDate + ' 至 ' + element.endDate)
          this.brandDemandEntity.flow += element.flowQuantity
        })

        this.brandDemandEntity.flow = toNumber(this.brandDemandEntity.flow)
        this.$emit('on-demand-stations', stationIds)
      })
    },
    showLineInfo () {
      this.showHistoryDemand = false
    },
    swipChange (index) {
      this.currentSwipePage = index
    }
  },
  computed: {
    isRuningCity () { // 是否为运行的城市
      return ['350200', '370200'].indexOf(this.cityCode) > -1
    }
  }
}
</script>
